export default {
  header: {
    title: 'Edut',
  },
  content: {
    title: 'Sinulla on {{balance}} pistettä',
    description:
      'Kuluta {{amount}}, saat {{rewards}} pistettä! Lisää ilmaisia tuotteita koriisi ansaitsemillasi pisteillä.',
    articles: {
      title: 'Kerää pisteitä jokaisesta tilauksesta',
      spend_description: 'Joka {{amount}} kulutettu lisää {{rewards}} pistettä tilillesi.',
      redeem_title: 'Lunasta pisteesi',
      redeem_description:
        'Lunasta pisteitä ilmaisiin herkkuihin! Ansaitse palkintoja alkaen {{minSpendingLimit}} pisteestä, mikä vastaa {{amount}} kulutusta',
      discounts_title: 'Löydä eksklusiiviset edut',
      discounts_description: 'Avaa pääsy eksklusiivisiin tarjouksiin ja alennuksiin.',
    },
  },
};
